import { MailAddressSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useMailAddressSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = MailAddressSchema({
    RequiredMessage: t('Validate_Required'),
    MailMessage: t('Validate_Mail'),
    MinLengthMessage: (min: number) => t('Validate_MinLength', { min }),
    MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
  });
  return schema;
};
